import Drawer from '@/parts/drawer';
import Vue, { defineComponent } from 'vue';
export default Vue.component('drawer-feature-detail', 
// @ts-ignore
defineComponent({
    extends: Drawer,
}));
